import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';
import * as _ from 'underscore';

import { NavListService } from './nav-list.service';
import { SessionService } from '../shared';

export class MenuController {
   dropdown:{brandOpen:boolean,campaignOpen:boolean};
   dropdownToken:{org?,brand?,campaign?} = null;

   showArchived = false;

   static $inject = ['$state', '$timeout', 'titleService', 'session', 'navList'];

   constructor(
      private $state:uir.StateService,
      private $timeout:ng.ITimeoutService,
      private titleService,
      private session:SessionService,
      private navList:NavListService
   ) { }

   get title():string {
      return this.titleService.getTitle();
   }

   get userName():string {
      return this.session.getUser().name || this.session.getUser().handle;
   }

   dropdownSelect(token) {
      if (!this.dropdownToken) {
         this.dropdownToken = token;
      } else {
         if (token.org) this.dropdownToken.org = token.org;
         if (token.brand) this.dropdownToken.brand = token.brand;
         if (token.campaign) this.dropdownToken.campaign = token.campaign;
      }

      // $timeout() workaround issue with dropdowns staying open and other
      // weird bugs after an entry inside the dropdown is selected.
      // contention with ui-bootstrap dropdown's is-open binding seems to be
      // the source of this problem, running on the next digest cycle fixes it.
      // having any amount of delay in the timeout seems to also be a problem
      // with the selected entry reverting to previous selection when changed.

      if (!this.dropdownToken.brand && !this.dropdownToken.campaign) {
         this.$timeout(() => {
            this.dropdown.brandOpen = true;
         });
      }

      if (this.dropdownToken.brand && !this.dropdownToken.campaign) {
         this.$timeout(() => {
            this.dropdown.brandOpen = false;
            this.dropdown.campaignOpen = true;
         });
      }

      if (this.dropdownToken.campaign) {
         if (this.dropdownToken.org) {
            this.session.setOrg(this.dropdownToken.org.id);
         }

         if (this.dropdownToken.brand) {
            this.session.setBrand(this.dropdownToken.brand.id);
         }

         this.session.setCampaign(this.dropdownToken.campaign.id);

         this.dropdownToken = null;

         if (this.$state.current.name == 'dashboard') {
            this.$state.reload();
         } else {
            this.$state.go('dashboard');
         }
      }
   }

   dropdownToggle() {
      if (!this.dropdown.brandOpen && !this.dropdown.campaignOpen) {
         this.dropdownToken = null;
      }
   }

   get orgs() {
      return this.session.getOrgs();
   }

   get org() {
      if (this.dropdownToken) {
         return this.dropdownToken.org;
      }

      return this.session.getOrg();
   }

   get brand() {
      if (this.dropdownToken) {
         return this.dropdownToken.brand;
      }

      return this.session.getBrand();
   }

   get campaign() {
      if (this.dropdownToken) {
         return null;
      }

      return this.session.getCampaign();
   }

   get campaigns() {
      // brand is undefined while switching orgs
      if (this.brand) {
         if (this.showArchived) {
            return this.brand.campaigns;
         } else {
            return _.filter(this.brand.campaigns as any[], c => !c.archived);
         }
      }
   }

   get disableOrganizationSelection() {
      if (this.$state.current.data) {
         return this.$state.current.data.disableOrganizationSelection;
      }

      return false;
   }

   get disableBrandSelection() {
      if (this.$state.current.data) {
         return this.$state.current.data.disableBrandSelection;
      }

      return false;
   }

   get disableCampaignSelection() {
      if (this.$state.current.data) {
         return this.$state.current.data.disableCampaignSelection;
      }

      return false;
   }

   logout() {
      this.session.logout();
   }

   get showNav() { return this.navList.showNav; }
   set showNav(v) { this.navList.showNav = v; }
}

ng.module('e360').component('menu', {
   templateUrl: require('./menu.html'),
   controller: MenuController
});
